export default __webpack_public_path__ + "static/media/2474eb2dbf3a5db79699e6f9255b4b4b.f5014afa.png";